import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { useQueryCacheManager } from '../../hooks/useQueryCacheManager';
import { ReactQueryConstants } from '../../commons/constants';
import { QueryStatus } from '../../commons/components/QueryStatus';
import useApi from '../../api/backendApiContext';

export const useFetchedFunding = () => {
  const queryCacheManager = useQueryCacheManager();
  const queryKey = queryCacheManager.getFundingCacheKey();
  const { fundingApi } = useApi();
  const query = useQuery(queryKey, async () => fundingApi.getFunding(), {
    staleTime: ReactQueryConstants.fundingStaleTime,
    refetchInterval: ReactQueryConstants.fundingRefetchTime,
  });
  const queryStatusComponent = (
    <QueryStatus
      queryKey={queryKey}
      queryStatus={query.status}
      dataTestPrefix="funding"
      failedToLoadText="Something went wrong. Try reloading the page several times. If the issue persists, contact support@growegy.com"
    />
  );
  return {
    query,
    queryStatusComponent,
  };
};
